export default {
  buttons: {
    go_to_basket: 'Przejdź do koszyka',
  },
};
